import React, { useState, useEffect } from 'react';

export default function Haji() {
  const [showContacts, setShowContacts] = useState(false);
  const [showFurodaDetail, setShowFurodaDetail] = useState(false);
  const [showKhususDetail, setShowKhususDetail] = useState(false);

  const [usdFuroda, setUsdFuroda] = useState('6000'); // Harga USD untuk Haji Furoda
  const [usdKhusus, setUsdKhusus] = useState('4500'); // Harga USD untuk Haji Khusus
  const [usdMunajat, setUsdMunajat] = useState('10000'); // Harga USD untuk Haji Munajat
  const [usdMahabbah, setUsdMahabbah] = useState('15000'); // Harga USD untuk Haji Mahabbah
  const [usdValueDetail, setUsdValueDetail] = useState(18500);
  const [usdValueDetail2, setUsdValueDetail2] = useState(20500);

  const [idRupiahFuroda, setIdRupiahFuroda] = useState(''); // IDR untuk Haji Furoda
  const [idRupiahKhusus, setIdRupiahKhusus] = useState(''); // IDR untuk Haji Khusus
  const [idRupiahMunajat, setIdRupiahMunajat] = useState(''); // IDR untuk Haji Munajat
  const [idRupiahMahabbah, setIdRupiahMahabbah] = useState(''); // IDR untuk Haji Mahabbah
  const [idRupiahDetail, setIdRupiahDetail] = useState(null);
  const [idRupiahDetail2, setIdRupiahDetail2] = useState(null);

  const [conversionRate, setConversionRate] = useState(null); // Kurs USD to IDR
  const [isConvertedDetail, setIsConvertedDetail] = useState(false);
  const [isConvertedDetail2, setIsConvertedDetail2] = useState(false);
  const [isConvertedFuroda, setIsConvertedFuroda] = useState(false); // Menyimpan status konversi untuk Haji Furoda
  const [isConvertedKhusus, setIsConvertedKhusus] = useState(false); // Menyimpan status konversi untuk Haji Khusus
  const [isConvertedMunajat, setIsConvertedMunajat] = useState(false); // Menyimpan status konversi untuk Haji Khusus
  const [isConvertedMahabbah, setIsConvertedMahabbah] = useState(false); // Menyimpan status konversi untuk Haji Khusus

  // Mengambil kurs USD ke IDR dari API (Currency API)

  const convertToIDRFuroda = async () => {
    try {
      // Jika conversionRate belum ada, lakukan fetch untuk mendapatkan nilai kurs konversi
      if (!conversionRate) {
        const response = await fetch(
          'https://api.freecurrencyapi.com/v1/latest?apikey=fca_live_MZUEJPGoRogWXIEWeGY38MfRopK4449SGWHmAfsj&currencies=IDR'
        );
        const data = await response.json();

        console.log(data);

        // Memastikan data yang diterima memiliki IDR conversion rate
        if (data?.data?.IDR) {
          setConversionRate(data.data.IDR); // Update conversionRate
        } else {
          console.error('IDR conversion rate not found in API response');
        }
      }

      // Melakukan konversi USD ke IDR setelah mendapatkan conversionRate
      if (conversionRate && usdFuroda) {
        const usdValue = parseFloat(usdFuroda); // Menggunakan usdFuroda untuk Haji Furoda
        const convertedToIDR = (usdValue * conversionRate).toFixed(0);
        setIdRupiahFuroda(convertedToIDR);
        setIsConvertedFuroda(true); // Tampilkan harga dalam Rupiah untuk Haji Furoda
      }

      if (conversionRate && usdValueDetail) {
        const convertedValue = (usdValueDetail * conversionRate).toFixed(0);
        setIdRupiahDetail(convertedValue);
        setIsConvertedDetail(true); // Set state to true to show converted amount
      }
    } catch (error) {
      console.error('Error fetching conversion rate:', error);
    }
  };

  useEffect(() => {
    // Ensure conversion rate and USD values are available before converting
    if (conversionRate) {
      // Convert USD Furoda to IDR
      if (usdFuroda) {
        const usdFurodaValue = parseFloat(usdFuroda); // Convert usdFuroda to a number
        const convertedFurodaToIDR = (usdFurodaValue * conversionRate).toFixed(
          0
        );
        setIdRupiahFuroda(convertedFurodaToIDR);
        setIsConvertedFuroda(true); // Set flag to show conversion for Haji Furoda
      }

      // Convert USD Khusus to IDR
      if (usdKhusus) {
        const usdKhususValue = parseFloat(usdKhusus); // Convert usdKhusus to a number
        const convertedKhususToIDR = (usdKhususValue * conversionRate).toFixed(
          0
        );
        setIdRupiahKhusus(convertedKhususToIDR);
        setIsConvertedKhusus(true); // Set flag to show conversion for Haji Khusus
      }

      // Convert USD Munajat to IDR
      if (usdMunajat) {
        const usdMunajatValue = parseFloat(usdMunajat); // Convert usdKhusus to a number
        const convertedMunajatToIDR = (
          usdMunajatValue * conversionRate
        ).toFixed(0);
        setIdRupiahMunajat(convertedMunajatToIDR);
        setIsConvertedMunajat(true); // Set flag to show conversion for Haji Khusus
      }

      // Convert USD Mahabbah to IDR
      if (usdMahabbah) {
        const usdMahabbahValue = parseFloat(usdMahabbah); // Convert usdKhusus to a number
        const convertedMahabbahToIDR = (
          usdMahabbahValue * conversionRate
        ).toFixed(0);
        setIdRupiahMahabbah(convertedMahabbahToIDR);
        setIsConvertedMahabbah(true); // Set flag to show conversion for Haji Khusus
      }

      // Convert USD Detail to IDR
      if (usdValueDetail) {
        const usdValueDetailValue = parseFloat(usdValueDetail); // Convert usdValueDetail to a number
        const convertedDetailToIDR = (
          usdValueDetailValue * conversionRate
        ).toFixed(0);
        setIdRupiahDetail(convertedDetailToIDR);
        setIsConvertedDetail(true); // Set flag to show conversion for Haji Detail
      }

      if (usdValueDetail2) {
        const usdValueDetailValue2 = parseFloat(usdValueDetail2); // Convert usdValueDetail to a number
        const convertedDetailToIDR = (
          usdValueDetailValue2 * conversionRate
        ).toFixed(0);
        setIdRupiahDetail2(convertedDetailToIDR);
        setIsConvertedDetail2(true); // Set flag to show conversion for Haji Detail
      }
    }
  }, [
    conversionRate,
    usdFuroda,
    usdKhusus,
    usdMunajat,
    usdMahabbah,
    usdValueDetail,
    usdValueDetail2,
  ]); // Dependencies to trigger the effect when any of the values change

  useEffect(() => {
    if (window.location.hash === '#paket-haji') {
      const paketHajiSection = document.getElementById('paket-haji');
      if (paketHajiSection) {
        paketHajiSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [window.location.hash]);

  // Fungsi untuk mengonversi USD Haji Khusus ke IDR
  const convertToIDRKhusus = async () => {
    // Check if the conversion rate is available, if not fetch it first
    if (!conversionRate) {
      await convertToIDRFuroda(); // Fetch conversion rate if not already available
    }

    // Perform conversion only if conversionRate and usdKhusus are available
    if (conversionRate && usdKhusus) {
      const usdValue = parseFloat(usdKhusus); // Using usdKhusus for the Haji Khusus package
      const convertedToIDR = (usdValue * conversionRate).toFixed(0); // Convert USD to IDR
      setIdRupiahKhusus(convertedToIDR); // Set the IDR value for Haji Khusus
      setIsConvertedKhusus(true); // Set the conversion flag to true for displaying conversion
    }
  };

  const convertToIDRMunajat = async () => {
    // Check if the conversion rate is available, if not fetch it first
    if (!conversionRate) {
      await convertToIDRFuroda(); // Fetch conversion rate if not already available
    }

    // Perform conversion only if conversionRate and usdKhusus are available
    if (conversionRate && usdMunajat) {
      const usdValue = parseFloat(usdMunajat); // Using usdKhusus for the Haji Khusus package
      const convertedToIDR = (usdValue * conversionRate).toFixed(0); // Convert USD to IDR
      setIdRupiahMunajat(convertedToIDR); // Set the IDR value for Haji Khusus
      setIsConvertedMunajat(true); // Set the conversion flag to true for displaying conversion
    }
  };

  const convertToIDRMahabbah = async () => {
    // Check if the conversion rate is available, if not fetch it first
    if (!conversionRate) {
      await convertToIDRFuroda(); // Fetch conversion rate if not already available
    }

    // Perform conversion only if conversionRate and usdKhusus are available
    if (conversionRate && usdMahabbah) {
      const usdValue = parseFloat(usdMahabbah); // Using usdKhusus for the Haji Khusus package
      const convertedToIDR = (usdValue * conversionRate).toFixed(0); // Convert USD to IDR
      setIdRupiahMahabbah(convertedToIDR); // Set the IDR value for Haji Khusus
      setIsConvertedMahabbah(true); // Set the conversion flag to true for displaying conversion
    }
  };

  const convertToIDRDetail = async () => {
    // Check if the conversion rate is available, if not fetch it first
    if (!conversionRate) {
      await convertToIDRFuroda(); // Fetch conversion rate if not already available
    }

    // Perform conversion only if conversionRate and usdValueDetail are available
    if (conversionRate && usdValueDetail) {
      const usdValue = parseFloat(usdValueDetail); // Using usdValueDetail for the Haji detail
      const convertedToIDR = (usdValue * conversionRate).toFixed(0); // Convert USD to IDR
      setIdRupiahDetail(convertedToIDR); // Set the IDR value
      setIsConvertedDetail(true); // Set the conversion flag to true for displaying conversion
    }
  };

  const convertToIDRDetail2 = async () => {
    // Check if the conversion rate is available, if not fetch it first
    if (!conversionRate) {
      await convertToIDRFuroda(); // Fetch conversion rate if not already available
    }

    // Perform conversion only if conversionRate and usdValueDetail are available
    if (conversionRate && usdValueDetail2) {
      const usdValue = parseFloat(usdValueDetail2); // Using usdValueDetail for the Haji detail
      const convertedToIDR = (usdValue * conversionRate).toFixed(0); // Convert USD to IDR
      setIdRupiahDetail2(convertedToIDR); // Set the IDR value
      setIsConvertedDetail2(true); // Set the conversion flag to true for displaying conversion
    }
  };

  const handleFurodaClick = (e) => {
    e.preventDefault();
    // Ketika mengklik Detail Paket Haji Furoda, sembunyikan Detail Haji Khusus
    setShowFurodaDetail(!showFurodaDetail);
    setShowKhususDetail(false); // Menyembunyikan Haji Khusus
  };

  // Fungsi untuk toggle showKhususDetail
  const handleKhususClick = (e) => {
    e.preventDefault();
    // Ketika mengklik Detail Paket Haji Khusus, sembunyikan Detail Haji Furoda
    setShowKhususDetail(!showKhususDetail);
    setShowFurodaDetail(false); // Menyembunyikan Haji Furoda
  };

  const handleBackClick = () => {
    window.location.hash = '#paket-haji'; // Mengubah hash

    // Menunggu agar render selesai dan kemudian melakukan scroll
    setTimeout(() => {
      const paketHajiSection = document.getElementById('paket-haji');
      if (paketHajiSection) {
        paketHajiSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 0);

    setShowFurodaDetail(false); // Kembali ke tampilan awal
    setShowKhususDetail(false); // Kembali ke tampilan awal
  };

  const toggleContacts = () => {
    setShowContacts(!showContacts);
  };

  return (
    <div>
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                Paket Perjalanan
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Beranda</a>
                  </li>
                  <li
                    className="breadcrumb-item text-white active"
                    aria-current="page"
                  >
                    Paket Perjalanan
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* Paket Haji Start */}
      <div className="container-xxl py-5" id="paket-haji">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Paket Perjalanan
            </h6>
            <h1 className="mb-5" style={{ color: 'black' }}>
              Paket Haji: Furoda & Khusus (ONH+)
            </h1>
          </div>

          <div className="row g-4 justify-content-center">
            {/* Tampilkan paket Haji Furoda dan Khusus berdasarkan kondisi showFurodaDetail */}
            {!showFurodaDetail && !showKhususDetail ? (
              <>
                {/* Paket Haji Furoda */}
                <div
                  className="col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
                  data-wow-delay="0.1s"
                >
                  <div className="package-item h-100 d-flex flex-column">
                    <div className="overflow-hidden">
                      <img
                        className="img-fluid w-100"
                        src="./assets/img/haji/haji-furoda.jpg"
                        alt="Haji Furoda"
                      />
                    </div>
                    <div className="d-flex border-bottom">
                      <small className="flex-fill text-center border-end py-2">
                        <i className="fa fa-calendar-alt text-primary me-2" />
                        24 Hari
                      </small>
                      <small className="flex-fill text-center py-2">
                        <i className="fa fa-user text-primary me-2" />
                        Quota Resmi Tanpa Antre
                      </small>
                    </div>
                    <div className="text-center p-4 flex-grow-1 d-flex flex-column justify-content-between">
                      <div>
                        <span className="badge bg-primary mb-2">
                          Haji Furoda
                        </span>
                        <h3 className="mb-0" style={{ color: 'black' }}>
                          {isConvertedFuroda
                            ? `Uang Muka Rp ${idRupiahFuroda}`
                            : `Uang Muka $${usdFuroda}`}
                        </h3>
                        <p>
                          Program haji tanpa antre dengan visa Mujamalah,
                          akomodasi hotel bintang 5 dekat Masjidil Haram dan
                          Nabawi.
                        </p>
                        <button
                          onClick={toggleContacts}
                          style={{
                            fontSize: '14px',
                            padding: '8px 16px',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                          }}
                          className="contact-button"
                        >
                          <i
                            className="fas fa-phone-alt"
                            style={{ marginRight: '8px' }}
                          ></i>
                          Hubungi Kami
                        </button>

                        {showContacts && (
                          <div
                            style={{
                              textAlign: 'center',
                              fontSize: '18px',
                              marginTop: '10px',
                            }}
                          >
                            <p>
                              Rafi:{' '}
                              <a
                                href="https://wa.me/082136361688"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                WhatsApp
                              </a>
                            </p>
                            <p>
                              Nanang:{' '}
                              <a
                                href="https://wa.me/081288596966"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                WhatsApp
                              </a>
                            </p>
                            <p>
                              Call Center:{' '}
                              <a
                                href="https://wa.me/08118810491"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                WhatsApp
                              </a>
                            </p>
                          </div>
                        )}
                      </div>
                      <a
                        href="#"
                        className="btn btn-outline-primary mt-3"
                        onClick={handleFurodaClick}
                      >
                        Lihat Detail Paket
                      </a>
                      {/* Tombol Konversi Haji Furoda */}
                      <button
                        className="btn btn-outline-primary-konversi mt-3"
                        onClick={convertToIDRFuroda}
                      >
                        Konversi ke Rupiah
                      </button>
                    </div>
                  </div>
                </div>

                {/* Paket Haji Khusus */}
                <div
                  className="col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
                  data-wow-delay="0.3s"
                >
                  <div className="package-item h-100 d-flex flex-column">
                    <div className="overflow-hidden">
                      <img
                        className="img-fluid w-100"
                        src="./assets/img/haji/haji-khusus.jpg"
                        alt="Haji Khusus"
                      />
                    </div>
                    <div className="d-flex border-bottom">
                      <small className="flex-fill text-center border-end py-2">
                        <i className="fa fa-calendar-alt text-primary me-2" />
                        23 Hari
                      </small>
                      <small className="flex-fill text-center py-2">
                        <i className="fa fa-user text-primary me-2" />
                        ONH Plus Resmi Kemenag
                      </small>
                    </div>
                    <div className="text-center p-4 flex-grow-1 d-flex flex-column justify-content-between">
                      <div>
                        <span className="badge bg-primary mb-2">
                          Haji Khusus (ONH+)
                        </span>
                        <h3 className="mb-0" style={{ color: 'black' }}>
                          {isConvertedKhusus
                            ? `Uang Muka Rp ${idRupiahKhusus}`
                            : `Uang Muka $${usdKhusus}`}
                        </h3>
                        <p>
                          Paket resmi kuota haji Kemenag dengan layanan
                          eksklusif, hotel dekat dan manasik intensif.
                        </p>
                        <button
                          onClick={toggleContacts}
                          style={{
                            fontSize: '14px',
                            padding: '8px 16px',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                          }}
                          className="contact-button"
                        >
                          <i
                            className="fas fa-phone-alt"
                            style={{ marginRight: '8px' }}
                          ></i>
                          Hubungi Kami
                        </button>

                        {showContacts && (
                          <div
                            style={{
                              textAlign: 'center',
                              fontSize: '18px',
                              marginTop: '10px',
                            }}
                          >
                            <p>
                              Rafi:{' '}
                              <a
                                href="https://wa.me/082136361688"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                WhatsApp
                              </a>
                            </p>
                            <p>
                              Nanang:{' '}
                              <a
                                href="https://wa.me/081288596966"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                WhatsApp
                              </a>
                            </p>
                            <p>
                              Call Center:{' '}
                              <a
                                href="https://wa.me/08118810491"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                WhatsApp
                              </a>
                            </p>
                          </div>
                        )}
                      </div>
                      <a
                        href="#"
                        className="btn btn-outline-primary mt-3"
                        onClick={handleKhususClick}
                      >
                        Lihat Detail Paket
                      </a>
                      {/* Tombol Konversi Haji Khusus */}
                      <button
                        className="btn btn-outline-primary-konversi mt-3"
                        onClick={convertToIDRKhusus}
                      >
                        Konversi ke Rupiah
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* Jika showFurodaDetail true, tampilkan detail Haji Furoda */}
                {showFurodaDetail && (
                  <div className="col-12 text-center">
                    <div className="h-100">
                      <img
                        className="img-fluid w-50 mb-4"
                        src="./assets/img/haji/haji-furoda.jpg"
                        alt="Detail Haji Furoda"
                      />
                      <h3 style={{ color: 'black' }}>
                        Detail Paket Haji Furoda
                      </h3>
                      <p class="stabilo1">
                        Tak lagi khawatir akan antrian, melalui haji furoda
                        ibadah haji dapat ditunaikan langsung tanpa masa tunggu
                        dan antrian yang lama. Jamaah haji furoda Sanema Tour
                        akan mendapatkan jaminan 100% uang kembali jika visa
                        tidak terbit, bimbingan manasik di hotel, hotel yang
                        nyaman dan layanan handling penuh.
                      </p>
                      <div className="row g-4 justify-content-center">
                        {/* Paket Mina (Ekonomis) */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Mina"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Mina <br />
                                <span style={{ color: '#cfa936' }}>
                                  (Ekonomis)
                                </span>
                              </h3>
                              <p className="text-white position-absolute bottom-0 start-50 translate-middle-x text-poppins">
                                {isConvertedDetail
                                  ? `Dimulai Dari Rp ${idRupiahDetail}`
                                  : `Dimulai Dari $${usdValueDetail}`}
                              </p>
                            </div>
                            <div className="text-center">
                              <button
                                onClick={convertToIDRDetail}
                                className="btn btn-outline-primary-konversi w-100"
                              >
                                Konversi Ke Rupiah
                              </button>
                            </div>

                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa resmi untuk perjalanan Haji"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa resmi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Penerbangan langsung menggunakan pesawat Saudia Airlines/Garuda Indonesia"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Penerbangan langsung menggunakan pesawat
                                      Saudia Airlines/Garuda Indonesia
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Mekkah yang diatur oleh mashair"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Hotel Mekkah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah dengan fasilitas setara bintang lima"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Hotel Madinah Grand Plaza/Setaraf</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Transit di Mekkah diatur oleh mashair"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Hotel Transit Mekkah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tenda Maktab diatur oleh mashair untuk kenyamanan lebih"
                                  >
                                    <i
                                      className="fa fa-bed text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tenda Maktab</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Fasilitas Kereta Cepat antara Mekkah dan Madinah"
                                  >
                                    <i
                                      className="fa fa-train text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Kereta Cepat Mekkah – Madinah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Haji selama 24 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 24 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan Haji eksklusif disediakan"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Perlengkapan Haji Ekslusif</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Manasik Haji diadakan di Hotel 1-3 kali"
                                  >
                                    <i
                                      className="fa fa-hotel text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Manasik Haji di Hotel 1-3x</p>
                                  </div>

                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Private Bus</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fas fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Free Air Zam Zam"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Air Zam-zam</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#minapackageDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div id="minapackageDetails" className="collapse">
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket Mina:
                                </h5>
                                <p>
                                  Paket Haji Ekonomis ini menawarkan pengalaman
                                  ibadah Haji yang nyaman dengan biaya yang
                                  lebih terjangkau. Dilengkapi dengan fasilitas
                                  penginapan yang memadai di Hotel Mekkah dan
                                  Hotel Madinah Grand Plaza/Setaraf, paket ini
                                  memberikan kenyamanan selama tinggal di dua
                                  kota suci. Penginapan di Tenda Maktab juga
                                  sudah disediakan untuk menjamin kenyamanan
                                  saat menjalani ibadah di Mina. Meskipun lebih
                                  ekonomis, paket ini tetap memberikan fasilitas
                                  lengkap dan pengalaman yang baik selama
                                  pelaksanaan ibadah Haji.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Arafah */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Mina"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Arafah <br />
                                <span className="text-gold exclusive">
                                  (Ekslusif)
                                </span>
                              </h3>
                              <p className="text-white position-absolute bottom-0 start-50 translate-middle-x text-poppins">
                                {isConvertedDetail
                                  ? `Dimulai Dari Rp ${idRupiahDetail2}`
                                  : `Dimulai Dari $${usdValueDetail2}`}
                              </p>
                            </div>
                            <div className="text-center">
                              <button
                                onClick={convertToIDRDetail2}
                                className="btn btn-outline-primary-konversi w-100"
                              >
                                Konversi Ke Rupiah
                              </button>
                            </div>

                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-placement="top"
                                    title="Visa resmi untuk perjalanan Haji"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa resmi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-placement="top"
                                    title="Penerbangan langsung menggunakan pesawat Saudia Airlines/Garuda Indonesia"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Penerbangan langsung menggunakan pesawat
                                      Saudia Airlines/Garuda Indonesia
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Mekkah yang diatur oleh mashair"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Hotel Mekkah Pullman/Setaraf</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah dengan fasilitas setara bintang lima"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Hotel Madinah Dallah Taibah/Setaraf</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Transit di Mekkah diatur oleh mashair"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Hotel Transit Mekkah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tenda Maktab diatur oleh mashair untuk kenyamanan lebih"
                                  >
                                    <i
                                      className="fa fa-bed text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tenda Maktab VIP</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Fasilitas Kereta Cepat antara Mekkah dan Madinah"
                                  >
                                    <i
                                      className="fa fa-train text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Kereta Cepat Mekkah – Madinah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Haji selama 24 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 24 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan Haji eksklusif disediakan"
                                  >
                                    <i
                                      className="fa fa-tshirt text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Perlengkapan Haji Ekslusif</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Manasik Haji diadakan di Hotel 1-3 kali"
                                  >
                                    <i
                                      className="fa fa-hotel text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Manasik Haji di Hotel 1-3x</p>
                                  </div>

                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Private Bus</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Air Zam-zam</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#arafahpackageDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div id="arafahpackageDetails" className="collapse">
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket Arafah:
                                </h5>
                                <p>
                                  Paket Haji Ekslusif dirancang untuk memberikan
                                  kenyamanan lebih dengan penginapan yang lebih
                                  mewah dan fasilitas premium. Di Hotel Mekkah
                                  Pullman/Setaraf dan Hotel Madinah Dallah
                                  Taibah/Setaraf, Anda akan merasakan kenyamanan
                                  bintang lima dengan akses yang lebih dekat ke
                                  lokasi-lokasi ibadah. Selain itu, paket ini
                                  juga menawarkan Tenda Maktab VIP, yang
                                  memberikan kenyamanan lebih dengan fasilitas
                                  yang lebih lengkap dan privasi lebih baik.
                                  Dengan fasilitas premium ini, perjalanan Haji
                                  Anda akan semakin nyaman dan penuh berkah.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Tombol Kembali */}
                      <div className="col-12 text-center">
                        <button
                          className="btn btn-outline-danger mt-3"
                          onClick={handleBackClick}
                        >
                          Kembali
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {/* Tampilkan detail Haji Khusus berdasarkan kondisi showKhususDetail */}
                {showKhususDetail && (
                  <div className="col-12 text-center">
                    <div className="h-100">
                      <img
                        className="img-fluid w-50 mb-4"
                        src="./assets/img/haji/haji-khusus.jpg"
                        alt="Detail Haji Khusus"
                      />
                      <h3 style={{ color: 'black' }}>
                        Detail Paket Haji Khusus
                      </h3>
                      <p class="stabilo1">
                        Melalui haji khusus, ibadah bisa diwujudkan dengan masa
                        tunggu yang lebih singkat hanya 5-9 tahun. Dilengkapi
                        fasilitas yang super nyaman dan memudahkan ibadah serta
                        bimbingan langsung oleh pembimbing yang kompeten membuat
                        perjalanan suci terasa makin berarti.
                      </p>
                      <div className="row g-4 justify-content-center">
                        {/* Paket Munajat */}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Munajat"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Munajat
                                <br />
                                <span style={{ color: '#cfa936' }}>
                                  (Ekonomis)
                                </span>
                              </h3>
                              <p className="text-white position-absolute bottom-0 start-50 translate-middle-x text-poppins">
                                {isConvertedMunajat
                                  ? `Dimulai Dari Rp ${idRupiahMunajat}`
                                  : `Dimulai Dari $${usdMunajat}`}
                              </p>
                            </div>
                            <div className="text-center">
                              <button
                                onClick={convertToIDRMunajat}
                                className="btn btn-outline-primary-konversi w-100"
                              >
                                Konversi Ke Rupiah
                              </button>
                            </div>

                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Visa resmi untuk perjalanan Haji"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa resmi </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Penerbangan langsung menggunakan pesawat Saudia Airlines/Garuda Indonesia (OK)"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Penerbangan langsung menggunakan pesawat
                                      Saudia Airlines/Garuda Indonesia
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Mekkah yang diatur oleh mashair"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Mekkah: Anjum Hotel/setaraf bintang
                                      5
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah dengan fasilitas setara bintang lima"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah Grand Plaza/Setaraf Bintang
                                      5
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Transit di Mekkah diatur oleh mashair"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Hotel Transit Bintang 2</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tenda Maktab diatur oleh mashair untuk kenyamanan lebih"
                                  >
                                    <i
                                      className="fa fa-bed text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tenda Maktab Standar</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Fasilitas Kereta Cepat antara Mekkah dan Madinah"
                                  >
                                    <i
                                      className="fa fa-train text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Kereta Cepat Mekkah – Madinah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Haji selama 24 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 23 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan Haji eksklusif disediakan"
                                  >
                                    <i
                                      className="fa fa-user-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Perlengkapan Haji Ekslusif</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Manasik Haji diadakan di Hotel 1-3 kali"
                                  >
                                    <i
                                      className="fa fa-hotel text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Manasik Haji di Hotel 3x</p>
                                  </div>

                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Waktu tunggu 5-9 tahun (menyesuaikan estimasi dari Kemenag RI)"
                                  >
                                    <i
                                      className="fa fa-calendar-day text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Waktu tunggu 5-9 tahun (menyesuaikan
                                      estimasi dari Kemenag RI)
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Private Bus</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Makan 3x Sehari"
                                  >
                                    <i
                                      className="fa fa-drumstik-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Welcome Food"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Free Air Zam Zam"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Air Zam-zam</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Free Dokumentasi"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang Berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Full Handling"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Full Service"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#munajatpackageDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="munajatpackageDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket Munajat:
                                </h5>
                                <p>Paket Haji Munajat</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Paket Mahabbah*/}
                        <div
                          className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp"
                          data-wow-delay="0.1s"
                        >
                          <div className="pricing-card package-item h-100 d-flex flex-column p-4 border-0 rounded-3 shadow-lg">
                            <div className="pricing-header text-center mb-4 position-relative">
                              <img
                                src="assets/img/banner/artboard-1.jpg"
                                alt="Paket Mahabbah"
                                className="w-100 rounded-3 img-fluid"
                              />
                              <h3 className="text-white position-absolute top-50 start-50 translate-middle">
                                Paket Mahabbah
                                <br />
                                <span className="text-gold exclusive">
                                  (Ekslusif)
                                </span>
                              </h3>
                              <p className="text-white position-absolute bottom-0 start-50 translate-middle-x text-poppins">
                                {isConvertedMahabbah
                                  ? `Dimulai Dari Rp ${idRupiahMahabbah}`
                                  : `Dimulai Dari $${usdMahabbah}`}
                              </p>
                            </div>
                            <div className="text-center">
                              <button
                                onClick={convertToIDRMahabbah}
                                className="btn btn-outline-primary-konversi w-100"
                              >
                                Konversi Ke Rupiah
                              </button>
                            </div>

                            <div className="pricing-features mb-4">
                              <div className="row">
                                {/* Menampilkan fitur dalam dua kolom */}
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-placement="top"
                                    title="Visa resmi untuk perjalanan Haji"
                                  >
                                    <i
                                      className="fa fa-address-book text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Visa resmi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-placement="top"
                                    title="Penerbangan langsung menggunakan pesawat Saudia Airlines/Garuda Indonesia"
                                  >
                                    <i
                                      className="fa fa-plane text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Penerbangan langsung menggunakan pesawat
                                      Saudia Airlines/Garuda Indonesia
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Mekkah yang diatur oleh mashair"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Mekkah: Movepink/Setaraf Bintang 5
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Madinah dengan fasilitas setara bintang lima"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Hotel Madinah: Maden/Setaraf Bintang 5
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Hotel Transit di Mekkah diatur oleh mashair"
                                  >
                                    <i
                                      className="fa fa-building text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Hotel Transit Bintang 3</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tenda Maktab diatur oleh mashair untuk kenyamanan lebih"
                                  >
                                    <i
                                      className="fa fa-bed text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Tenda Maktab 112/114/Setaraf</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Fasilitas Kereta Cepat antara Mekkah dan Madinah"
                                  >
                                    <i
                                      className="fa fa-train text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Kereta Cepat Mekkah – Madinah</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Program Haji selama 24 Hari"
                                  >
                                    <i
                                      className="fa fa-calendar text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Program 23 Hari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Perlengkapan Haji eksklusif disediakan"
                                  >
                                    <i
                                      className="fa fa-user-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Perlengkapan Haji Ekslusif</p>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Manasik Haji diadakan di Hotel 1-3 kali"
                                  >
                                    <i
                                      className="fa fa-hotel text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Manasik Haji di Hotel 3x</p>
                                  </div>

                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Waktu tunggu 5-9 tahun (menyesuaikan estimasi dari Kemenag RI)"
                                  >
                                    <i
                                      className="fa fa-calendar-day text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Waktu tunggu 5-9 tahun (menyesuaikan
                                      estimasi dari Kemenag RI)
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Akses ke lounge eksklusif di lokasi tertentu"
                                  >
                                    <i
                                      className="fa fa-snowflake text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Lounge</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Private Bus"
                                  >
                                    <i
                                      className="fa fa-bus text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Private Bus</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Makan 3x Sehari"
                                  >
                                    <i
                                      className="fa fa-drumstick-bite text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Makan 3x Sehari</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Welcome Food"
                                  >
                                    <i
                                      className="fa fa-cookie text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Welcome Food</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Free Air Zam-Zam"
                                  >
                                    <i
                                      className="fa fa-tint text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Air Zam-zam</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Free Dokumentasi"
                                  >
                                    <i
                                      className="fa fa-camera text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Free Dokumentasi</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Tour Leader dan Muthawif yang Berkompeten"
                                  >
                                    <i
                                      className="fa fa-users text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>
                                      Tour Leader dan Muthawif yang Berkompeten
                                    </p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Full Handling"
                                  >
                                    <i
                                      className="fa fa-tools text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Handling</p>
                                  </div>
                                  <div
                                    className="feature-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Full Service"
                                  >
                                    <i
                                      className="fa fa-check-circle text-primary mb-2"
                                      style={{ fontSize: '2rem' }}
                                    ></i>
                                    <p>Full Service</p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="text-center mt-auto">
                              <button
                                className="btn btn-primary w-100 mt-3"
                                data-bs-toggle="collapse"
                                data-bs-target="#mahabbahpackageDetails"
                              >
                                Deskripsi Paket
                              </button>
                            </div>

                            <div
                              id="mahabbahpackageDetails"
                              className="collapse"
                            >
                              <div className="mt-3 p-3 bg-light rounded">
                                <h5
                                  className="font-weight-bold"
                                  style={{ color: 'goldenrod' }}
                                >
                                  Detail Paket Mahabbah:
                                </h5>
                                <p>Paket Haji Mahabbah</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Tombol Kembali */}
                      <div className="col-12 text-center">
                        <button
                          className="btn btn-outline-danger mt-3"
                          onClick={handleBackClick}
                        >
                          Kembali
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {/* Paket Haji End */}
    </div>
  );
}
